import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 700">
      <rect x="0" y="0" rx="5" ry="5" width="175" height="180"/>
      <rect x="0" y="185" rx="5" ry="5" width="175" height="20"/>

      <rect x="205" y="0" rx="5" ry="5" width="175" height="180"/>
      <rect x="205" y="185" rx="5" ry="5" width="175" height="20"/>

      <rect x="0" y="240" rx="5" ry="5" width="175" height="180"/>
      <rect x="0" y="425" rx="5" ry="5" width="175" height="20"/>

      <rect x="205" y="240" rx="5" ry="5" width="175" height="180"/>
      <rect x="205" y="425" rx="5" ry="5" width="175" height="20"/>

      <rect x="0" y="480" rx="5" ry="5" width="175" height="180"/>
      <rect x="0" y="665" rx="5" ry="5" width="175" height="20"/>

      <rect x="205" y="480" rx="5" ry="5" width="175" height="180"/>
      <rect x="205" y="665" rx="5" ry="5" width="175" height="20"/>
    </ContentLoader>
  )

}
